module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-gray-dark-on-red-248be791a017f0cf24284cbf5680ed13.png";